var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1123_21456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2 12C0.53625 12 0 12.5362 0 13.2C0 13.8638 0.53625 14.4 1.2 14.4H2.4V16.8H1.2C0.53625 16.8 0 17.3363 0 18C0 18.6638 0.53625 19.2 1.2 19.2H22.8C23.4638 19.2 24 18.6638 24 18C24 17.3363 23.4638 16.8 22.8 16.8H21.6V14.4H22.8C23.4638 14.4 24 13.8638 24 13.2C24 12.5362 23.4638 12 22.8 12H1.2ZM4.8 14.4H10.8V16.8H4.8V14.4ZM13.2 14.4H19.2V16.8H13.2V14.4Z",
    fill: "#EE7225"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1123_21456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPallet);
export default __webpack_public_path__ + "static/media/pallet.7542cf9784fcc142b2e2b49b29cb8d08.svg";
export { ForwardRef as ReactComponent };